const BASE_URL = process.env.REACT_APP_BASE_URL;

// Custom fetch BASE for protected/restricted routes that requires auth token..
const fetchPrivate = async (url, options = {}) => {
  const requestOptions = {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
    },
  };

  try {
    console.log(`Fetching private route: ${BASE_URL}${url}`, requestOptions);

    const response = await fetch(`${BASE_URL}${url}`, requestOptions);
    return response;
  } catch (error) {
    return error;
  }
};

export default fetchPrivate;
